import type { ListColor } from "@kontaktfix/shared";

export const LIST_COLOR_HEX: Record<ListColor, string> = {
  gray: "#8b8d98",
  iris: "#5b5bd6",
  blue: "#0090ff",
  teal: "#12a594",
  green: "#30a46c",
  amber: "#e2a336",
  orange: "#f76b15",
  red: "#e5484d",
  pink: "#d6409f",
  violet: "#8e4ec6",
};

export function ListBadge({ name, color }: { name: string; color: ListColor }) {
  return (
    <span className="inline-flex h-5 max-w-40 items-center gap-1.5 rounded-[5px] border border-border bg-bg px-1.5 text-[11.5px] font-medium text-fg-muted">
      <span className="size-1.5 shrink-0 rounded-full" style={{ background: LIST_COLOR_HEX[color] }} />
      <span className="truncate">{name}</span>
    </span>
  );
}
